import { SvgIcon } from '@mui/material';
import { memo } from 'react';

const ChargeIcon = (props) => (
  <SvgIcon {...props} style={{ fill: 'none', stroke: 'none' }}>
    <path
      d='m8.65 18.125 1.775-3.25h-1.05v-2.5l-1.8 3.225H8.65ZM6 10.5h6V5.625q0-.25-.188-.437Q11.625 5 11.375 5h-4.75q-.25 0-.437.188Q6 5.375 6 5.625ZM6 19h6v-7.5H6Zm-1 1V5.625q0-.7.463-1.162Q5.925 4 6.625 4h4.75q.7 0 1.163.463.462.462.462 1.162v6h.975q.65 0 1.113.45.462.45.462 1.1v4.6q0 .55.425.95.425.4 1 .4t1-.4q.425-.4.425-.95v-8.9h-.35q-.35 0-.575-.225-.225-.225-.225-.575V6.5h.4V5.375h.775V6.5h.85V5.375h.775V6.5h.4v1.575q0 .35-.237.575-.238.225-.588.225H19.3v8.9q0 .925-.687 1.575-.688.65-1.638.65t-1.637-.65q-.688-.65-.688-1.575v-4.6q0-.3-.187-.487-.188-.188-.488-.188H13V20Zm7-1H6h6Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default memo(ChargeIcon);
